import { render } from "./ReturnForm.vue?vue&type=template&id=73375f52"
import script from "./ReturnForm.vue?vue&type=script&lang=js"
export * from "./ReturnForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__